import { Company } from '@/types/company';
import { Team } from '@/types/teams';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type MultiTenantState = {
  // For channel partner admins - selected company context
  selectedCompanyId: string | null;
  selectedCompany: Company | null;
  // For company admins/managers - selected team context
  selectedTeamId: string | null;
  selectedTeam: Team | null;
  // Cache for companies and teams
  companies: Company[];
  teams: Team[];
};

const initialState: MultiTenantState = {
  selectedCompanyId: null,
  selectedCompany: null,
  selectedTeamId: null,
  selectedTeam: null,
  companies: [],
  teams: [],
};

export const multiTenantSlice = createSlice({
  name: 'multiTenant',
  initialState,
  reducers: {
    setSelectedCompany: (state, action: PayloadAction<Company | null>) => {
      state.selectedCompany = action.payload;
      state.selectedCompanyId = action.payload?.uuid || null;
    },
    setSelectedTeam: (state, action: PayloadAction<Team | null>) => {
      state.selectedTeam = action.payload;
      state.selectedTeamId = action.payload?.uuid || null;
    },
    setCompanies: (state, action: PayloadAction<Company[]>) => {
      state.companies = action.payload;
    },
    setTeams: (state, action: PayloadAction<Team[]>) => {
      state.teams = action.payload;
    },
    clearMultiTenantState: (state) => {
      state.selectedCompanyId = null;
      state.selectedCompany = null;
      state.selectedTeamId = null;
      state.selectedTeam = null;
      state.companies = [];
      state.teams = [];
    },
  },
});

export const {
  setSelectedCompany,
  setSelectedTeam,
  setCompanies,
  setTeams,
  clearMultiTenantState,
} = multiTenantSlice.actions;

export const multiTenantReducer = multiTenantSlice.reducer;
